import React, { ReactNode } from 'react';
import { Logo } from '@whoop/web-components';
import styles from './index.module.scss';

interface CenteredCardLayoutProps {
  children: ReactNode;
}

function CenteredCardLayout({ children }: CenteredCardLayoutProps) {
  return (
    <div className={styles.root}>
      <div>
        <div className={styles.logoWrapper}>
          <Logo className={styles.logo} variant="trademark" />
        </div>
        <div className={styles.card}>
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </div>
  );
}

export default CenteredCardLayout;
